export default __webpack_public_path__ + "static/media/AlertSearch.bb5ba48e.svg";